import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faYoutube,
    faFacebook,
    faInstagram,
    faXTwitter,
    faTelegram,
    faReddit,
} from '@fortawesome/free-brands-svg-icons';

class Support extends React.Component {
    render() {
        return (
            <div className="container">
                <div className="section-heading inverse">
                    <a href="/contact.html" target="_blank" style={{textDecoration: 'none', color: 'inherit'}}>
                        <h1 style={{cursor: 'pointer', transition: 'opacity 0.3s ease'}}>Contact us</h1>
                    </a>
                    <div className="spacer"/>
                    <h2 className="gradient-header">
                        <a href="/contact.html" target="_blank" style={{textDecoration: 'underline', color: 'inherit'}}>
                            Contact AT Player team to get support.
                        </a>
                        <br/>
                        <a href="/contact.html" target="_blank" style={{textDecoration: 'underline', color: 'inherit'}}>
                            We <span style={{color: 'red'}}>❤️</span> to hear your feedback!
                        </a>
                    </h2>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="platforms inverse">
                            <a href="https://www.reddit.com/r/AT_Player_App/" target="_blank"
                               className="btn btn-primary inverse custom-flex-btn">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faReddit} className="icon-reddit" />
                                </div>
                                <div className="text-wrapper">
                                    <span>Reddit community</span>
                                    <div>AT Player</div>
                                </div>
                            </a>
                            <a href="https://t.me/atplayerchat" target="_blank"
                               className="btn btn-primary inverse custom-flex-btn">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faTelegram} className="icon-telegram" />
                                </div>
                                <div className="text-wrapper">
                                    <span>Telegram chat</span>
                                    <div>AT Player</div>
                                </div>
                            </a>
                            <a href="https://m.me/atplayer" target="_blank"
                               className="btn btn-primary inverse custom-flex-btn">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faFacebook} className="icon-facebook" />
                                </div>
                                <div className="text-wrapper">
                                    <span>Facebook chat</span>
                                    <div>AT Player</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <footer>
                    <div className="container">
                        <div className="section-heading inverse">
                            <a href="/blog.html" target="_blank">
                                <p className="btn-link label-primary inverse">Blog</p>
                            </a>
                            <a href="/terms-of-use.html#dmca-copyright-policy" target="_blank">
                                <p className="btn-link label-primary inverse">Copyright Information</p>
                            </a>
                            <a href="/privacy-policy.html" target="_blank">
                                <p className="btn-link label-primary inverse">Privacy Policy</p>
                            </a>
                            <a href="/terms-of-use.html" target="_blank">
                                <p className="btn-link label-primary inverse">Terms of Use</p>
                            </a>
                            <a href="/copyright_complaint_form" target="_blank">
                                <p className="btn-link label-primary inverse">DMCA Notice Form</p>
                            </a>
                            <a href="/advertisement.html" target="_blank">
                                <p className="btn-link label-primary inverse">Advertising & Partnerships</p>
                            </a>
                            <a href="/faqs.html" target="_blank">
                                <p className="btn-link label-primary inverse">Frequently Asked Questions</p>
                            </a>
                        </div>
                        <div className="social">
                            <a href="https://www.youtube.com/c/atplayer" target="_blank">
                                <FontAwesomeIcon icon={faYoutube} size="lg" className="fa" />
                            </a>
                            <a href="https://www.reddit.com/r/AT_Player_App/" target="_blank">
                                <FontAwesomeIcon icon={faReddit} size="lg" className="fa" />
                            </a>
                            <a href="https://www.facebook.com/atplayer" target="_blank">
                                <FontAwesomeIcon icon={faFacebook} size="lg" className="fa" />
                            </a>
                            <a href="https://www.instagram.com/atmusicplayer" target="_blank">
                                <FontAwesomeIcon icon={faInstagram} size="lg" className="fa" />
                            </a>
                            <a href="https://twitter.com/atmusicplayer" target="_blank">
                                <FontAwesomeIcon icon={faXTwitter} size="lg" className="fa" />
                            </a>
                            <a href="https://t.me/atplayerchat" target="_blank">
                                <FontAwesomeIcon icon={faTelegram} size="lg" className="fa" />
                            </a>
                        </div>
                        <div className="rights">
                            <p>Copyright © 2026 Aktis Inc.</p>
                        </div>
                    </div>
                </footer>
            </div>
        )
    }
}

export default Support